module.exports = __webpack_public_path__ + "static/media/ifood-1.b6a93679.png";